import { render, staticRenderFns } from "./sSelectTypeCertification.vue?vue&type=template&id=1f4780ac"
import script from "./sSelectTypeCertification.vue?vue&type=script&lang=js"
export * from "./sSelectTypeCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports